/**
 * @generated SignedSource<<81391e58734230ef1443189a624c6b84>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type IssueRow_Old$data = {
  readonly __id: string;
  readonly issueId: string;
  readonly issueTypeField?: {
    readonly issueType: {
      readonly hierarchy?: {
        readonly level: number | null | undefined;
      } | null | undefined;
      readonly name: string;
    } | null | undefined;
  } | null | undefined;
  readonly key: string;
  readonly " $fragmentSpreads": FragmentRefs<"IssueKeyCell_fields" | "IssueSummaryCell_issue" | "LinkRelationshipTypeCell_issueRef" | "RichTextCell_issue">;
  readonly " $fragmentType": "IssueRow_Old";
};
export type IssueRow_Old$key = {
  readonly " $data"?: IssueRow_Old$data;
  readonly " $fragmentSpreads": FragmentRefs<"IssueRow_Old">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider"
    },
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isDensityFull"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isLinkRelationshipFieldEnabled"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isRemoteLinkedIssuesEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "IssueRow_Old",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "key"
    },
    {
      "kind": "ScalarField",
      "name": "issueId"
    },
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "concreteType": "JiraIssueTypeField",
          "kind": "LinkedField",
          "name": "issueTypeField",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraIssueType",
              "kind": "LinkedField",
              "name": "issueType",
              "plural": false,
              "selections": [
                {
                  "concreteType": "JiraIssueTypeHierarchyLevel",
                  "kind": "LinkedField",
                  "name": "hierarchy",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "level"
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "concreteType": "JiraIssueTypeField",
          "kind": "LinkedField",
          "name": "issueTypeField",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraIssueType",
              "kind": "LinkedField",
              "name": "issueType",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "name"
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "IssueSummaryCell_issue"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "isRemoteLinkedIssuesEnabled",
          "variableName": "isRemoteLinkedIssuesEnabled"
        }
      ],
      "kind": "FragmentSpread",
      "name": "IssueKeyCell_fields"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "isDensityFull",
          "variableName": "isDensityFull"
        }
      ],
      "kind": "FragmentSpread",
      "name": "RichTextCell_issue"
    },
    {
      "condition": "isLinkRelationshipFieldEnabled",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "LinkRelationshipTypeCell_issueRef"
        }
      ]
    },
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "__id"
        }
      ]
    }
  ],
  "type": "JiraIssue"
};

(node as any).hash = "298af0de9745a8285f40d946dc3074ae";

export default node;
